'use strict';

if (!customElements.get('video-slider')) {
  class VideoSlider extends HTMLElement {
    constructor() {
      super();
      this.swiper = null;
      this.videos = [];
      this.sectionId = '';
    }

    connectedCallback() {
      this.sectionId = this.dataset.sectionId;
      this.videos = Array.from(this.querySelectorAll('.video-slider__video'));

      // 设置视频点击事件
      this.setupVideoClickHandlers();
      
      // 等待 Swiper 库加载完成
      if (typeof Swiper !== 'undefined') {
        this.initSwiper();
      } else {
        // 如果 Swiper 还未加载，等待加载
        const checkSwiper = setInterval(() => {
          if (typeof Swiper !== 'undefined') {
            clearInterval(checkSwiper);
            this.initSwiper();
          }
        }, 100);
      }
    }

    initSwiper() {
      const autoplay = this.dataset.autoplay === 'true';
      const speed = parseInt(this.dataset.speed) * 1000 || 5000;

      const swiperParams = {
        effect: 'slide',
        slidesPerView: 1,
        spaceBetween: 0,
        loop: false,
        pagination: {
          el: `.swiper-pagination-${this.sectionId}`,
          clickable: true,
        },
        on: {
          init: () => {
            this.handleSlideChange(0);
          },
          slideChange: (swiper) => {
            this.handleSlideChange(swiper.activeIndex);
          },
        },
      };

      if (autoplay) {
        swiperParams.autoplay = {
          delay: speed,
          disableOnInteraction: false,
        };
      }

      try {
        this.swiper = new Swiper(this, swiperParams);
      } catch (error) {
        console.error('Swiper initialization failed:', error);
      }
    }

    handleSlideChange(activeIndex) {
      this.videos.forEach((video, index) => {
        const slideItem = video.closest('.video-slider__item');
        
        if (index === activeIndex) {
          // 切换到当前视频时，始终自动播放（忽略之前的暂停状态）
          video.play().catch((error) => {
            console.log('Video play failed:', error);
          });
          slideItem.classList.remove('is-paused');
        } else {
          // 暂停并重置其他视频
          video.pause();
          video.currentTime = 0;
          slideItem.classList.remove('is-paused');
        }
      });
    }

    setupVideoClickHandlers() {
      this.videos.forEach((video, index) => {
        const slideItem = video.closest('.video-slider__item');
        
        video.addEventListener('click', () => {
          // 点击切换播放/暂停状态
          if (video.paused) {
            video.play().catch((error) => {
              console.log('Video play failed:', error);
            });
            slideItem.classList.remove('is-paused');
          } else {
            video.pause();
            slideItem.classList.add('is-paused');
          }
        });
      });
    }

    disconnectedCallback() {
      // 清理资源
      if (this.swiper) {
        this.swiper.destroy(true, true);
        this.swiper = null;
      }
      
      this.videos.forEach(video => {
        video.pause();
        video.currentTime = 0;
      });
    }
  }

  customElements.define('video-slider', VideoSlider);
}


